import React from "react";
import "./ProduceStep.css";
import ContactSection from "../components/Contact/contact_homepage";

const StepToMake = () => {
  const steps = [
    {
      id: 1,
      number: "1",
      title: "เสนอราคา",
      description: "เสนอราคาตามขนาดและรูปเเบบที่ลูกค้าต้องการผลิต",
      icon: ""
    },
    {
      id: 2,
      number: "2",
      title: "วัดพื้นที่จริงหน้างาน",
      description: "เจ้าหน้าที่เข้าวัดพื้นที่หน้างานจริง",
      icon: ""
    },
    {
      id: 3,
      number: "3",
      title: "ออกแบบให้ตรงใจ",
      description: "ออกแบบ 3D และแบบฟังก์ชั่นให้ถูกใจ",
      icon: ""
    },
    {
      id: 4,
      number: "4",
      title: "ผลิตด้วยเครื่องจักรคุณภาพ",
      description: "ใช้เครื่องจักรคุณภาพสูงในการผลิต, เครื่องCNC เครื่องปิดขอบไม้  และเครื่องจักรสำหรับเจาะ",
      icon: ""
    },
    {
      id: 5,
      number: "5",
      title: "ติดตั้งด้วยช่างฝีมือ",
      description: "ประกอบและติดตั้งด้วยช่างฝีมือ",
      icon: ""
    },
    {
      id: 6,
      number: "6",
      title: "รับประกันคุณภาพ",
      description: "รับประกันคุณภาพสินค้า 1 ปี จากการผลิต มีใบรับประกัน",
      icon: ""
    }
  ];

  const handleConsultClick = () => {
    window.open('https://www.facebook.com/messages/t/100064243770130', '_blank');
  };

  const handleCallClick = () => {
    window.open('tel:083-9822661', '_self');
  };

  return (
    <div className="process-page" id="produce-step">
      {/* Header Section */}
      <div className="process-header">
        <h1>ขั้นตอนการสั่งผลิต</h1>
        <p>กระบวนการทำงานที่มีมาตรฐาน และ ใส่ใจทุกรายละเอียด</p>
      </div>

      {/* Steps Grid */}
      <div className="steps-container">
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div 
              key={step.id} 
              className="step-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="step-header">
                <div className="step-number">{step.number}</div>
                <div className="step-icon">{step.icon}</div>
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              
              {/* Progress connector (except for last item) */}
              {index < steps.length - 1 && (
                <div className="step-connector"></div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="process-cta">
        <div className="cta-content">
          <h2>ต้องการปรึกษาการออกแบบ?</h2>
          <p>ทีมงานมืออาชีพพร้อมให้คำปรึกษาและออกแบบตามความต้องการของคุณ</p>
          <div className="cta-buttons">
            <button 
              className="cta-button primary"
              onClick={handleConsultClick}
              aria-label="ปรึกษาผ่าน Facebook"
            >
              ปรึกษาฟรี
            </button>
            <button 
              className="cta-button secondary"
              onClick={handleCallClick}
              aria-label="โทรปรึกษา"
            >
              โทรเลย
            </button>
          </div>
        </div>
      </div>

      <ContactSection />
    </div>
  );
};

export default StepToMake;